import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_tenant_order_approvers_and_sales_reps, loading_retrieve_tenant_order_approvers_and_sales_reps, reset_retrieve_tenant_order_approvers_and_sales_reps, success_retrieve_tenant_order_approvers_and_sales_reps } from '../../reducers/auth_tenant/retrieve_tenant_order_approvers_and_sales_reps_Slice';
import { RETRIEVE_TENANT_ORDER_APPROVALS_AND_SALES_REPRESENTATIVES_ERROR_MSG, RETRIEVE_TENANT_ORDER_APPROVALS_AND_SALES_REPRESENTATIVES_SUCCESS_MSG, TENANT_UPDATE_ORDER_APPROVERS_ERROR_MSG, TENANT_UPDATE_ORDER_APPROVERS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';
import * as app_consts from "../../utils/app_consts";
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { useParams } from 'react-router';
import { fail_tenant_update_order_approvers, loading_tenant_update_order_approvers, reset_tenant_update_order_approvers, success_tenant_update_order_approvers } from '../../reducers/auth_tenant/tenant_update_order_approvers_Slice';
import { RETRIEVE_TENANT_AGENCY_APPROVERS_DETAILS_API, TENANT_UPDATE_AGENCY_ORDER_APPROVERS_API } from '../../api/api_data';
import { Button, Col, Icon, Row, RSelect } from '../Component';
import TextInput from '../../pages/components/inputs/TextInput';

const initial_state = { id_one: "", id_two: "" };

const ViewAgencyOrderAproversModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction }) => {

  const { id } = useParams();
  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retrieved_data, setRetrievedData] = useState([]);
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [sales_reps_data, setSalesRepsData] = useState([]);
  const [current_sales_reps_data, setCurrentSalesRepsData] = useState([]);
  const [formData, setFormData] = useState(initial_state);

  const [update_loading, setUpdateLoading] = useState(false);
  const [update_error, setUpdateError] = useState("");


  useEffect(() => {
    if (isOpen)
    {
      setFormData(initial_state);
      // Dispatch
      retrieve_approval_settings();
    }
    setOpen(isOpen);
  }, [isOpen]);

  const retrieve_approval_settings = () => {
    setError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_order_approvers_and_sales_reps, success_retrieve_tenant_order_approvers_and_sales_reps, fail_retrieve_tenant_order_approvers_and_sales_reps, RETRIEVE_TENANT_ORDER_APPROVALS_AND_SALES_REPRESENTATIVES_ERROR_MSG, RETRIEVE_TENANT_ORDER_APPROVALS_AND_SALES_REPRESENTATIVES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_AGENCY_APPROVERS_DETAILS_API}/${id}`));
  };

  // Listener
  const retrieve_tenant_order_approvers_and_sales_reps_listener = useSelector((state) => state.retrieve_tenant_order_approvers_and_sales_reps.retrieve_tenant_order_approvers_and_sales_reps);

  useEffect(() => {
    if (retrieve_tenant_order_approvers_and_sales_reps_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_order_approvers_and_sales_reps_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_order_approvers_and_sales_reps_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_order_approvers_and_sales_reps_listener.message);
          messageToast(retrieve_tenant_order_approvers_and_sales_reps_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_order_approvers_and_sales_reps_listener.status === app_consts.SUCCESS)
        {
          const remapped_sales_reps = retrieve_tenant_order_approvers_and_sales_reps_listener.data?.sales_reps?.map((rep) => {
            return {
              label: `${rep?.name} - ${rep?.mobile_number}`,
              value: rep?.id
            };
          });
          setSalesRepsData(remapped_sales_reps);

          setRetrievedData(retrieve_tenant_order_approvers_and_sales_reps_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_order_approvers_and_sales_reps());
      }
    }
  }, [retrieve_tenant_order_approvers_and_sales_reps_listener]);


  const getSelectedOption = (value, options) => {
    return options?.find(option => option.value === value) || null;
  };

  const handle_id_one_change = (e) => {
    const new_mapped_data = sales_reps_data?.filter((rep) => { return rep?.value !== e?.value; });
    setCurrentSalesRepsData(new_mapped_data);
    setFormData({ ...formData, id_one: e?.value, id_two: "" });
  };

  const handleUpdateOrderApprovers = () => {
    setError("");
    // Dispatch
    const sent_data = { ...formData, id: id };
    dispatch(tenant_auth_actions_helper(loading_tenant_update_order_approvers, success_tenant_update_order_approvers, fail_tenant_update_order_approvers, TENANT_UPDATE_ORDER_APPROVERS_ERROR_MSG, TENANT_UPDATE_ORDER_APPROVERS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_AGENCY_ORDER_APPROVERS_API}`, sent_data));
  };

  // Listener
  const tenant_update_order_approvers_listener = useSelector((state) => state.tenant_update_order_approvers.tenant_update_order_approvers);

  useEffect(() => {
    if (tenant_update_order_approvers_listener.status !== app_consts.IDLE)
    {
      if (tenant_update_order_approvers_listener.status === app_consts.LOADING)
      {
        setUpdateLoading(true);
        setUpdateError("");
      } else
      {
        setUpdateLoading(false);
        if (tenant_update_order_approvers_listener.status === app_consts.FAIL)
        {
          setUpdateError(tenant_update_order_approvers_listener.message);
          messageToast(tenant_update_order_approvers_listener.message, app_consts.FAIL);
        } else if (tenant_update_order_approvers_listener.status === app_consts.SUCCESS)
        {
          successFunction();
          retrieve_approval_settings();
        }
        dispatch(reset_tenant_update_order_approvers());
      }
    }
  }, [tenant_update_order_approvers_listener]);


  return (
    <>
      <Modal isOpen={open} toggle={update_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"md "}>
        <ModalHeader toggle={update_loading || loading ? "" : closeModal}>Order Approvers</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Order Approvers...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 16, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <div className='mt-4'>
                      </div>
                      {
                        editMode ?
                          <>
                            <Row className="g-4">
                              <Col lg={12}>
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      <label className="form-label mb text-md" htmlFor="retrunable">
                                        First Approver<span className='text-danger pr-2'>{` *`}</span>
                                      </label>
                                    </label>
                                  </div>
                                  <div className="w-100">
                                    <RSelect
                                      options={sales_reps_data}
                                      className="w-100"
                                      placeholder="Search"
                                      value={getSelectedOption(formData?.id_one, sales_reps_data)}
                                      onChange={(e) => handle_id_one_change(e)}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      <label className="form-label mb text-md" htmlFor="retrunable">
                                        Second Approver<span className='text-danger pr-2'>{` *`}</span>
                                      </label>
                                    </label>
                                  </div>
                                  <div className="w-100">
                                    <RSelect
                                      options={current_sales_reps_data}
                                      isDisabled={!formData?.id_one}
                                      className="w-100"
                                      placeholder="Search"
                                      value={getSelectedOption(formData?.id_two, current_sales_reps_data)}
                                      onChange={(e) => { setFormData({ ...formData, id_two: e?.value }); }}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <hr />
                            <Row className="g-4 mt-4">
                              {update_error && (
                                <div className="mb-3 w-100">
                                  <Alert color="danger" className="alert-icon">
                                    <Icon name="alert-circle" /> {update_error}{" "}
                                  </Alert>
                                </div>
                              )}
                              <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                <Button className='mx-2' onClick={() => setEditMode(false)} disabled={update_loading} color="gray">
                                  Cancel
                                </Button>
                                <Button onClick={handleUpdateOrderApprovers} disabled={
                                  (update_loading) ||
                                  !(formData?.id_one && formData?.id_two)
                                } color="primary">
                                  {update_loading ? <Spinner size="sm" color="light" /> : "Update Approvers"}
                                </Button>
                              </Col>
                            </Row>
                          </>
                          :
                          <>
                            {
                              retrieved_data?.approver_one && retrieved_data?.approver_two ?
                                <>
                                  <div className="m-auto d-flex flex-row justify-content-start align-center my-4" >
                                    <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData({ initial_state }); }} color="primary" size="sm">
                                      Edit Approvers
                                    </Button>
                                  </div>
                                  <Row className="g-4">
                                    <TextInput
                                      label="First Approver"
                                      type="text"
                                      id_val="first_approver"
                                      value={retrieved_data?.approver_one ? `${retrieved_data?.approver_one?.name} ${retrieved_data?.approver_one?.mobile_number}` : "--"}
                                      colSize="12"
                                      disabled
                                      name="first_approver"
                                    />
                                    <TextInput
                                      label="Second Approver"
                                      type="text"
                                      id_val="second_approval"
                                      value={retrieved_data?.approver_two ? `${retrieved_data?.approver_two?.name} ${retrieved_data?.approver_two?.mobile_number}` : "--"}
                                      colSize="12"
                                      disabled
                                      name="second_approval"
                                    />
                                  </Row>
                                </>
                                :
                                <>
                                  <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                                    <div className="text-soft fw-bold my-4" style={{ fontSize: 18 }}>Order Approvers Have not Been Set</div>
                                    <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData(initial_state); }} color="primary" size="sm">
                                      Add Approvers
                                    </Button>
                                  </div>
                                </>
                            }
                          </>
                      }
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>

    </>
  );
};

export default ViewAgencyOrderAproversModal;